export default {
  project: {
    listTitle: "Liste des projets",
    newProject: "Nouveau Projet :",
    name: "Nom du projet",
    namePlaceholder: "Entrez le nom du projet",
    description: "Description",
    descriptionPlaceholder: "Entrez la description du projet",
    myProjects: "Mes Projets",
    searchPlaceholder: "Rechercher par nom, description",
    addUser: "Ajouter un membre",
    updateProject: "Mettre à jour le projet",
    viewProject: "Voir les details du projet",
    showMembers: "Afficher les membres",
    leaveProject: "Quitter le projet",
    membersOfProject: "Membres du projet",
    deleteUser: "Supprimer l'utilisateur",
    setAdmin: "Définir comme administrateur",
    table: {
      name: "Nom du projet",
      description: "Description",
      actions: "Actions",
      yourProfile: "Votre profil",
      user: "Utilisateur",
      profile: "Profil",
      email: "Email"
    },
    deleteMember: {
      confirmMessage: "Êtes-vous sûr de vouloir supprimer ce membre du projet ?"
    },
    deleteProject: {
      confirmMessage: "Êtes-vous sûr de vouloir supprimer ce projet ? Cette action est irréversible."
    },
    adminMember:{
      title:"Définir comme administrateur du projet",
      confirmMessage: "Êtes-vous sûr de vouloir définir ce membre comme administrateur du projet ?"
    },
    addMember: {
      selectRole: "Sélectionner un rôle",
      addPopupTitle: "Ajout d'un membre",
      email: "Email",
      emailPlaceholder: "Adresse email du membre",
      role: "Role",
    },
    editProject: {
      viewPopupTitle: "Voir le détail",
      editPopupTitle: "Modifier un projet",
      name: "Nom",
      description: "Description",
      meterPriceRural2Wires: "Prix compteur rural (2 fils)",
      meterPriceRural4Wires: "Prix compteur rural (4 fils)",
      meterPriceUrban2Wires: "Prix compteur urbain (2 fils)",
      meterPriceUrban4Wires: "Prix compteur urbain (4 fils)",
      meterPriceUrban4Wires: "Prix compteur urbain (4 fils)",
      eligibilityRadius: "Distance d'éligibilité en mètre",
      potentialEligibilityRadius: "Marge supplémentaire d'éligibilité potentiel en mètre"
    },
    change:{
      title:"Changement de projet",
      message:"Voulez-vous vraiment changer de projet ?",
      message_2:"(La page sera rechargée.)"
    }
  }
}
